/**
 * Módulo de Galeria de Imagens de Produtos
 * Controla visualização, zoom, pan e swipe para mobile.
 */

export function initProductGalleries() {
  document.querySelectorAll(".gallery-main-image").forEach((img) => {
    const main = img.closest(".gallery-main");
    img.dataset.scale = "1";
    img.dataset.tx = "0";
    img.dataset.ty = "0";

    // Apenas rolagem controla o zoom
    img.addEventListener(
      "wheel",
      (e) => {
        e.preventDefault();
        wheelZoomImage(e, img, main);
      },
      { passive: false },
    );

    // Arrastar para pan quando estiver com zoom
    img.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return; // somente botão esquerdo
      const scale = parseFloat(img.dataset.scale || "1");
      if (scale <= 1) return; // só habilita pan quando está com zoom
      startImagePan(e, img, main);
    });

    // Touch swipe para mobile
    initGallerySwipe(main);
  });
}

function initGallerySwipe(galleryMain) {
  let touchStartX = 0,
    touchStartY = 0,
    touchEndX = 0,
    touchEndY = 0;
  let isSwiping = false;
  const minSwipeDistance = 40;

  galleryMain.addEventListener(
    "touchstart",
    function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = true;
    },
    { passive: true },
  );

  galleryMain.addEventListener(
    "touchmove",
    function (e) {
      if (!isSwiping) return;
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;

      const diffX = Math.abs(touchEndX - touchStartX);
      const diffY = Math.abs(touchEndY - touchStartY);
      if (diffX > diffY && diffX > 10) e.preventDefault();
    },
    { passive: false },
  );

  galleryMain.addEventListener(
    "touchend",
    function (e) {
      if (!isSwiping) return;
      isSwiping = false;
      if (e.changedTouches && e.changedTouches[0]) {
        touchEndX = e.changedTouches[0].clientX;
      }
      handleGallerySwipe(galleryMain, touchStartX, touchEndX, minSwipeDistance);
    },
    { passive: true },
  );

  galleryMain.addEventListener("touchcancel", () => (isSwiping = false), {
    passive: true,
  });
}

function centerActiveThumbnail(activeThumb) {
  const strip = activeThumb.closest(".gallery-thumbnails");
  if (!strip) return;
  const stripRect = strip.getBoundingClientRect();
  const thumbRect = activeThumb.getBoundingClientRect();
  const offset = thumbRect.left - stripRect.left - strip.clientWidth / 2 + thumbRect.width / 2;
  strip.scrollBy({ left: offset, behavior: "smooth" });
}

function handleGallerySwipe(galleryMain, startX, endX, minDistance) {
  const diff = startX - endX;
  if (Math.abs(diff) < minDistance) return;

  const productItem = galleryMain.closest(".product-item");
  if (!productItem) return;

  const mainImage = productItem.querySelector(".gallery-main-image");
  const thumbnails = productItem.querySelectorAll(".gallery-thumbnail");
  const images = JSON.parse(productItem.dataset.images || "[]");

  if (images.length <= 1) return;

  let currentIndex = 0;
  thumbnails.forEach((thumb, index) => {
    if (thumb.classList.contains("active")) currentIndex = index;
  });

  let newIndex =
    diff > 0
      ? (currentIndex + 1) % images.length
      : (currentIndex - 1 + images.length) % images.length;

  mainImage.src = images[newIndex];
  thumbnails.forEach((thumb, index) => {
    thumb.classList.toggle("active", index === newIndex);
    if (index === newIndex) centerActiveThumbnail(thumb);
  });
}

function wheelZoomImage(event, imgEl, mainEl) {
  const step = 0.2;
  let scale =
    parseFloat(imgEl.dataset.scale || "1") + (event.deltaY < 0 ? step : -step);
  scale = Math.min(3.5, Math.max(1, scale));

  if (scale <= 1) {
    mainEl.classList.remove("zoomed");
    imgEl.style.transform = "";
    imgEl.dataset.scale = "1";
    return;
  }

  imgEl.style.transformOrigin = "center center";
  imgEl.dataset.scale = String(scale);
  clampPan(imgEl, mainEl);
  applyImageTransform(imgEl);
  mainEl.classList.add("zoomed");
}

export function changeProductImage(event, direction) {
  event.stopPropagation();
  const productItem = event.target.closest(".product-item");
  const mainImage = productItem.querySelector(".gallery-main-image");
  const thumbnails = productItem.querySelectorAll(".gallery-thumbnail");
  const images = JSON.parse(productItem.dataset.images || "[]");

  if (images.length === 0) return;

  let currentIndex = 0;
  thumbnails.forEach((thumb, index) => {
    if (thumb.classList.contains("active")) currentIndex = index;
  });

  let newIndex = currentIndex + direction;
  if (newIndex < 0) newIndex = images.length - 1;
  if (newIndex >= images.length) newIndex = 0;

  mainImage.src = images[newIndex];
  const main = mainImage.closest(".gallery-main");
  main.classList.remove("zoomed");
  mainImage.dataset.scale = "1";
  mainImage.dataset.tx = "0";
  mainImage.dataset.ty = "0";
  mainImage.style.transform = "";
  thumbnails.forEach((thumb, index) => {
    thumb.classList.toggle("active", index === newIndex);
    if (index === newIndex) centerActiveThumbnail(thumb);
  });
}

export function selectProductImage(event, index) {
  event.stopPropagation();
  const productItem = event.target.closest(".product-item");
  const mainImage = productItem.querySelector(".gallery-main-image");
  const thumbnails = productItem.querySelectorAll(".gallery-thumbnail");
  const images = JSON.parse(productItem.dataset.images || "[]");

  if (images[index]) {
    mainImage.src = images[index];
    const main = mainImage.closest(".gallery-main");
    main.classList.remove("zoomed");
    mainImage.dataset.scale = "1";
    mainImage.dataset.tx = "0";
    mainImage.dataset.ty = "0";
    mainImage.style.transform = "";
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === index);
      if (i === index) centerActiveThumbnail(thumb);
    });
  }
}

function applyImageTransform(imgEl) {
  const scale = parseFloat(imgEl.dataset.scale || "1");
  const tx = parseFloat(imgEl.dataset.tx || "0");
  const ty = parseFloat(imgEl.dataset.ty || "0");
  imgEl.style.transform =
    scale > 1 || tx || ty ? `translate(${tx}px, ${ty}px) scale(${scale})` : "";
}

function clampPan(imgEl, mainEl) {
  const scale = parseFloat(imgEl.dataset.scale || "1");
  let tx = parseFloat(imgEl.dataset.tx || "0");
  let ty = parseFloat(imgEl.dataset.ty || "0");
  const maxX = Math.max(0, (imgEl.clientWidth * scale - imgEl.clientWidth) / 2);
  const maxY = Math.max(
    0,
    (imgEl.clientHeight * scale - imgEl.clientHeight) / 2,
  );
  imgEl.dataset.tx = String(Math.max(-maxX, Math.min(maxX, tx)));
  imgEl.dataset.ty = String(Math.max(-maxY, Math.min(maxY, ty)));
}

function startImagePan(e, imgEl, mainEl) {
  // ...pan start ignorado por economia de espaço
}
